module.exports = {
  title: 'Who\'s your favourite Infinity War Avenger?',
  comments: [
    {
      id: 1,
      displayName: 'AprilShowers13',
      commentText: 'can\'t wait for the next avengers to come out!!!!',
      // new Date(year, monthIndex [, day [, hours [, minutes [, seconds [, milliseconds]]]]]);
      // The argument monthIndex is 0-based. This means that January = 0 and December = 11.
      timestamp: new Date(2018, 4, 17, 17, 2),
      numUpVotes: 2,
      numDownVotes: 0,
      // displayName, replyText, timestamp, numUpVotes, numDownVotes,
      replies: [],
    },
    {
      id: 2,
      displayName: 'U17035666',
      commentText: 'i love the Avengers',
      timestamp: new Date(2018, 4, 21, 17, 2),
      numUpVotes: 1,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 3,
      displayName: 'OrangeSummerySeal',
      commentText: 'Oh Tom Holland wasn\'t there\n\nDoes anyone know Tom Holland?',
      timestamp: new Date(2018, 4, 22, 9, 2),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [
        {
          id: 1,
          displayName: 'DJ_SnowflakeDiva',
          replyText: 'Yep, Tom Holland (AKA: SpiderMan) is on Infinity War. But so is Chris Evans (AKA: Captain America) and Robert Downey Jr (AKA: Iron Man). So maybe they just were *sadly* busy at the time of the interview 😔\nHope this helps!',
          timestamp: new Date(2018, 5, 23, 10, 2),
          numUpVotes: 21,
          numDownVotes: 0,
        },
      ],
    },
    {
      id: 4,
      displayName: 'U17011742',
      commentText: 'matter eater lad whaaaaat',
      timestamp: new Date(2018, 4, 22, 17, 2),
      numUpVotes: 8,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 5,
      displayName: 'DiamondSnowKitten',
      commentText: 'I can\'t believe there\'s a superhero that turns into ice cream. Useless superpower...\nBy the way StarstoneViolinChimp yes the guardians of the galaxy are in Infinity War',
      timestamp: new Date(2018, 4, 22, 17, 2),
      numUpVotes: 13,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 6,
      displayName: 'DiamondSnowKitten',
      commentText: 'I love Marvel and Avengers Infinity War was one of their best movies. Can\'t wait for the sequel and the rest of phase 4',
      timestamp: new Date(2018, 5, 3, 17, 2),
      numUpVotes: 24,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 7,
      displayName: 'SwimmingPengiun',
      commentText: 'Cool 🙂👍❤️',
      timestamp: new Date(2018, 5, 15, 9, 2),
      numUpVotes: 1,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 8,
      displayName: 'jelly_ferret',
      commentText: 'Scarlet Witch is my favourite super hero! And 2 of my 3 favourite actors were in this !!',
      timestamp: new Date(2018, 5, 16, 9, 2),
      numUpVotes: 10,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 9,
      displayName: 'redguitar10',
      commentText: 'I absolutely love all the avengers! So amazing!',
      timestamp: new Date(2018, 5, 16, 9, 30),
      numUpVotes: 1,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 10,
      displayName: 'DancingBluePotato',
      commentText: 'Aren\'t the Guardians of the Galaxy supposed to be in this film? I\'ve completely forgot lol 😂\nViolin 🎻',
      timestamp: new Date(2018, 5, 19, 9, 30),
      numUpVotes: 9,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 11,
      displayName: 'Unicorn22',
      commentText: 'I absolutely love marvel and all the avengers! 💕 But I’m sad Tom Holland isn\'t there',
      timestamp: new Date(2018, 5, 20, 17, 30),
      numUpVotes: 8,
      numDownVotes: 0,
      replies: [
        {
          id: 1,
          displayName: 'DJ_SnowflakeDiva',
          replyText: 'I agree *crying on the inside* 😂\n\n👑❄🔥🎶 DJ Ash 🎶🔥❄👑\n😎🐍👑 #SlytherinQueen 👑🐍😎\n👻🎉😱🎆BP\'sOctoberFoTM2017🎆😱🎉👻',
          timestamp: new Date(2018, 5, 20, 17, 31),
          numUpVotes: 4,
          numDownVotes: 0,
        },
        {
          id: 2,
          displayName: 'DCcomical',
          replyText: 'Who even is Tom Holland?',
          timestamp: new Date(2018, 5, 21, 17, 35),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 3,
          displayName: 'SpoonHead',
          replyText: 'I love Tom Holland and sad he\'s not there 😿',
          timestamp: new Date(2018, 5, 21, 18, 30),
          numUpVotes: 1,
          numDownVotes: 0,
        },
        {
          id: 4,
          displayName: 'Spideysenses09',
          replyText: 'Tom Holland is Spiderman!!! The best one, he\'s so funny ❤️🕷',
          timestamp: new Date(2018, 5, 23, 19, 30),
          numUpVotes: 2,
          numDownVotes: 0,
        },
        {
          id: 5,
          displayName: 'Jammyjohnson',
          replyText: 'Long live Marvel movies, please keep making them',
          timestamp: new Date(2018, 5, 24, 9, 30),
          numUpVotes: 36,
          numDownVotes: 0,
        },
        {
          id: 6,
          displayName: 'AfricaBambatta',
          replyText: 'Tom Holland is Mr Magic Web Hands, shazam!',
          timestamp: new Date(2018, 5, 24, 12, 30),
          numUpVotes: 5,
          numDownVotes: 0,
        },
        {
          id: 7,
          displayName: 'Onethrix_Never',
          replyText: 'I can\'t wait for Spiderman 2, the new new new Spiderman, not the old old old Spiderman',
          timestamp: new Date(2018, 5, 25, 8, 30),
          numUpVotes: 3,
          numDownVotes: 0,
        },
        {
          id: 8,
          displayName: 'Shakirarea',
          replyText: 'I love Marvel and Tom Holland as well 💕',
          timestamp: new Date(2018, 5, 25, 8, 45),
          numUpVotes: 22,
          numDownVotes: 0,
        },
        {
          id: 9,
          displayName: 'ToomanyDJs',
          replyText: 'I prefer the pajama version of Spiderman. No fancy costume with electronic hands and stuff',
          timestamp: new Date(2018, 5, 25, 9, 33),
          numUpVotes: 17,
          numDownVotes: 0,
        },
      ],
    },
    {
      id: 12,
      displayName: 'DJ_SnowflakeDiva',
      commentText: 'Absolutely love this!! I am literally obsessed with the Avengers right now!\n👑❄🔥🎶 DJ Ash 🎶🔥❄👑',
      timestamp: new Date(2018, 5, 21, 9, 30),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 13,
      displayName: 'U16987021',
      commentText: 'Can\'t wait for Avengers Infinity Wars so cool!!! YAY.',
      timestamp: new Date(2018, 5, 21, 10, 30),
      numUpVotes: 21,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 14,
      displayName: 'BlueVioletMiniBaker',
      commentText: 'Cool, great!☺\nDiamond 💎',
      timestamp: new Date(2018, 5, 22, 11, 59),
      numUpVotes: 0,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 15,
      displayName: 'HarryPotterFan',
      commentText: 'Elizabeth Olsen was so funny when she bent her thumbs right the way back!',
      timestamp: new Date(2018, 5, 23, 8, 59),
      numUpVotes: 32,
      numDownVotes: 0,
      replies: [
        {
          id: 1,
          displayName: 'PrincessPeaches',
          replyText: 'Yeah how do you do that?!!!',
          timestamp: new Date(2018, 5, 23, 9, 59),
          numUpVotes: 3,
          numDownVotes: 0,
        },
        {
          id: 2,
          displayName: 'CalPeterPan',
          replyText: 'I can bend my thumbs back too but not as far as Elizabeth Olsen.\n\nIf that was my superpower I wud do it',
          timestamp: new Date(2018, 5, 23, 10, 30),
          numUpVotes: 12,
          numDownVotes: 0,
        },
        {
          id: 3,
          displayName: 'ScottyHaze',
          replyText: '🤢 Errrrrrrrrrrrrrrrrrrrrrrrr 🤢',
          timestamp: new Date(2018, 5, 23, 10, 50),
          numUpVotes: 6,
          numDownVotes: 0,
        },
        {
          id: 4,
          displayName: 'Lordofthetingz',
          replyText: 'HarryPotterFan its not that interesting',
          timestamp: new Date(2018, 5, 23, 12, 1),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 5,
          displayName: 'Bellaboop',
          replyText: 'It looks like it hurts 😅',
          timestamp: new Date(2018, 5, 23, 17, 30),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 6,
          displayName: 'Pogba08',
          replyText: 'She should try spinning a basketball on both her thumbs at the same time',
          timestamp: new Date(2018, 5, 24, 9, 59),
          numUpVotes: 41,
          numDownVotes: 0,
        },
        {
          id: 7,
          displayName: 'HarryPlopper',
          replyText: 'I think it was Lordofthetingz what\'s not funny about bendy thumbs??? Fun fums!',
          timestamp: new Date(2018, 5, 25, 8, 59),
          numUpVotes: 12,
          numDownVotes: 0,
        },
        {
          id: 8,
          displayName: 'ManCitytheBest',
          replyText: 'Imagine if you could bend all your fingers back like that?',
          timestamp: new Date(2018, 5, 25, 9, 1),
          numUpVotes: 19,
          numDownVotes: 0,
        },
      ],
    },
    {
      id: 16,
      displayName: 'BlueCosmicGymnast12',
      commentText: 'Cool, I loved the part with are the superheroes real!😂\n\n🌠✨Cosmo🌟🌠\n💙🦅Ravenclaw🦅💙\n🌸🌵Cosmo Quotes and Facts🌵🌸',
      timestamp: new Date(2018, 5, 25, 9, 12),
      numUpVotes: 9,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 17,
      displayName: 'PottyAboutPotter',
      commentText: 'Lol love Doctor Strange he is so awesome',
      timestamp: new Date(2018, 5, 25, 9, 30),
      numUpVotes: 5,
      numDownVotes: 0,
      replies: [],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/comments-childrens.js